import React from 'react';
import classNames from 'classnames';
import styles from './article-preview.module.scss';
import { ArticlePreviewInterface, ArticlePreviewSideEnum } from './article-preview.interface';

const ArticlePreview: React.FunctionComponent<ArticlePreviewInterface> = ({
  className,
  imageSide: imagesSide = ArticlePreviewSideEnum.RIGHT,
  imageUrl,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={classNames(
        styles.component,
        className,
        {
          [styles.isLeftImages]: imagesSide === ArticlePreviewSideEnum.LEFT,
        },
      )}
    >
      <div className={styles.content}>
        {children}
      </div>

      <div className={styles.imagesWrap}>
        <div
          className={styles.images}
          style={{
            backgroundImage: `url(${imageUrl})`,
          }}
        />
      </div>
    </div>
  );
};

export default ArticlePreview;
